// styles
import { Box, styled } from '@mui/material';

export const StyledHeader = styled(Box)({
  zIndex: 40,
  width: '100%',
  minHeight: 50
});

export const Top = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr', // ⬅️ left | centre | right
  alignItems: 'center',
  gap: 16,
  paddingBottom: 20,
  position: 'relative',

  '.MuiAutocomplete-root': {
    minWidth: 200
  }
});

export const DateNavigationContainer = styled(Box)({
  minWidth: 320,
  justifySelf: 'center'
});

export const PlanUnitSelectorContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(6),
  flexWrap: 'wrap',
  width: 550
}));
